import { Theme } from "@mui/material";

export const Variants = (theme: Theme) => {
  return {
    primary: {
      backgroundColor: theme.colors["neutral.900"],
      borderRadius: "8px"
    },
    secondary: {
      backgroundColor: theme.colors["neutral.950"],
      borderRadius: "8px"
    }
  }
}

export const SizeStyles = (theme: Theme) => {
  return {
    xs: {
      fontSize: theme.fontSizes.sm,
      '& .MuiInputBase-input': {
        padding: `${theme.space._150} ${theme.space._300} `,
      }
    },
    sm: {
      fontSize: theme.fontSizes.sm,
      '& .MuiInputBase-input': {
        padding: `${theme.space._200} ${theme.space._300} `,
      }
    },
    md: {
      fontSize: theme.fontSizes.md,
      '& .MuiInputBase-input': {
        padding: `${theme.space._300}`,
      }
    },
    lg: {
      fontSize: theme.fontSizes.lg,
      '& .MuiInputBase-input': {
        padding: `${theme.space._400} ${theme.space._300} `,
      }
    },
  };
};

export const CustomStyles = (theme: Theme) => {
  return {
    fullWidth: {
      width: '100%',
      '.MuiInputBase-input': {
        width: "100%",
      }
    },
  }
}

export const Types = (theme: Theme) => {
  return {
    default: {
      '.MuiInputBase-input': {
        width: "176px",
      }
    },
    numbersOnly: {
      '.MuiInputBase-input': {
        width: "40px",
      }
    }
  }
}